export const hasPermission = (
  input: { permissions: { permissionId: string }[] },
  permission: string,
) => input.permissions.some((p) => p.permissionId === permission);
